
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./frontend-general/index.js');

import { createApp } from 'vue'
const app = createApp({});
app.component('price-breakdown-tabs', require('./frontend-components/PriceBreakdownTabs.vue').default);
app.component('price-breakdown', require('./frontend-components/PriceBreakdown.vue').default);
app.component('single-price-breakdown', require('./frontend-components/SinglePriceBreakdown.vue').default);
app.component('blog-posts', require('./frontend-components/BlogPosts.vue').default);
app.component('discount-calculate', require('./frontend-components/DiscountCalculate.vue').default);
app.mount('#app')


